import pythonLogo from "../assets/optimized/python.webp";
import jsLogo from "../assets/optimized/js2.webp";
import dockerLogo from "../assets/optimized/docker.webp";
import awsLogo from "../assets/optimized/aws.webp";
import gcpLogo from "../assets/optimized/gcp.webp";
import tfLogo from "../assets/optimized/tf.webp";
import pytorchLogo from "../assets/optimized/pytorch.webp";
import langchainLogo from "../assets/optimized/langchain.webp";
import reactLogo from "../assets/optimized/react.webp";
import { motion } from "framer-motion";
import { FiCpu } from "react-icons/fi";

const skills = [
  { logo: pythonLogo, alt: "Python" },
  { logo: tfLogo, alt: "TensorFlow" },
  { logo: pytorchLogo, alt: "PyTorch" },
  { logo: langchainLogo, alt: "LangChain", darkBadge: true },
  { logo: dockerLogo, alt: "Docker", darkBadge: true },
  { logo: awsLogo, alt: "AWS" },
  { logo: gcpLogo, alt: "GCP" },
  { logo: reactLogo, alt: "React" },
  { logo: jsLogo, alt: "JavaScript", darkBadge: true },
];

function Skills() {
  return (
    <section id="tech-stack" className="section-shell">
      <div className="section-heading">
        <p className="section-title">Tech stack</p>
        <span className="section-icon" aria-hidden="true"><FiCpu /></span>
      </div>
      <div className="skill-bento-grid">
        {skills.map((skill, index) => (
          <motion.div
            key={skill.alt}
            className="skill-bento-card"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.35, delay: index * 0.04, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className={`skill-bento-icon${skill.darkBadge ? " skill-bento-icon--dark" : ""}`}>
              <img src={skill.logo} alt="" width="28" height="28" decoding="async" />
            </span>
            <span className="skill-bento-label">{skill.alt}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
